import React from "react";

const variantClasses = {
  default:
    "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
  secondary:
    "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
  destructive:
    "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
  outline: "text-foreground",
};

const baseClasses =
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors " +
  "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2";

export function Badge({ className, variant = "default", children, ...props }) {
  const classes = [baseClasses, variantClasses[variant], className].join(" ");

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}
